// Pure throttle decision for usePendingSummary's focus/visibility re-fetch. No React —
// unit-testable. DB-side changes (e.g. a credit reset) have no frontend event, so a
// throttled re-fetch on tab refocus is how the banner/badge catch up. No periodic polling.

export const REFOCUS_THROTTLE_MS = 10000;

/**
 * Re-fetch on refocus only when the tab is visible AND at least throttleMs has elapsed
 * since the last fetch.
 */
export function shouldRefetchOnRefocus(now, lastFetch, visibilityState, throttleMs = REFOCUS_THROTTLE_MS) {
  if (visibilityState === 'hidden') return false;
  return (now - lastFetch) >= throttleMs;
}
